'use client';
import { IconButton, Text } from '@stone-payments/jade';

interface ShippingAddressReviewProps {
  shippingAddress: {
    street: string;
    number: string;
    city: string;
    state: string;
    zip: string;
    country: string;
  };
  editShippingAddress: () => void;
}

export function ShippingAddressReview({
  shippingAddress,
  editShippingAddress,
}: ShippingAddressReviewProps) {
  return (
    <div className="flex flex-row gap-jade-200 mt-jade-50 py-jade-200 px-jade-200 bg-jade-background-surface rounded-jade-small border border-solid border-jade-border-low shadow-sm">
      <div style={{ width: '90%' }}>
        <Text weight="semibold">
          {shippingAddress.street}, {shippingAddress.number}
        </Text>
        <Text>
          {shippingAddress.city} - {shippingAddress.state}
        </Text>
        <Text>CEP {shippingAddress.zip}</Text>
        <Text>{shippingAddress.country}</Text>
      </div>
      <div className="flex items-center align-middle">
        <IconButton
          size="small"
          icon={'action-edit'}
          onClick={editShippingAddress}
        ></IconButton>
      </div>
    </div>
  );
}
